export const PROFILE_SUBPAGE_SLIDE_MS = 420;

export const PROFILE_SUBPAGE_PATHS = new Set([
  "/buy-credits",
  "/visibility-boosts",
  "/terms",
  "/privacy",
]);

export function isProfileSubpageRoute(pathname, state) {
  return PROFILE_SUBPAGE_PATHS.has(pathname) && Boolean(state?.fromProfile);
}

export function buildProfileSubpageState(extra = {}) {
  return { subpageSlide: true, fromProfile: true, ...extra };
}
